import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

const BoxContainer = ({ className, children, ...props }) => {
  const classes = useStyles(props);

  return (
    <section className={`${classes.root} ${className ? className : ""}`}>
      {children}
    </section>
  );
};

export default BoxContainer;
